import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'

Vue.use(Vuex)
Vue.config.productionTip = false

let state = new Vuex.Store({});

new Vue({
  router,
  store: state,
  render: h => h(App)
}).$mount('#app')
